import PraisoServices from "./PraisoServices";
import { updateSession } from "./LocalStorageService";
import { getToken } from "./LocalStorageService";

export const SessionAPI = async (session, params) => {
  const ApiUrl = `sessions`;
  const token = getToken();
  // if (params.impersonationid) {
  //   session.impersonationId = params.impersonationid;
  // }
  try {
    const response = await PraisoServices(
      ApiUrl,
      "put",
      {
        ...session,
      },
      {},
      {
        Authorization: `Bearer ${token}`,
      }
    );
    try {
      return response;
    } catch (error) {
      const err = error as Error;
      return {
        status: {
          code: 1,
          message: err?.message,
        },
        content: null,
      };
    }
  } catch (error_1) {
    const err = error_1 as Error;
    return {
      status: {
        code: 1,
        message: err.message,
      },
      content: null,
    };
  }
};

export const changeSession = async (session, params) => {
  //Remove the cache API response to load the new API response for changed session
  window.localStorage.removeItem("API");
  const data = await SessionAPI(session, params);
  if (
    data.status.code !== 0 &&
    data.status.code !== 200 &&
    data.status.code !== 201
  ) {
    return data;
  } else {
    /** @todo: Neutralising the time zone date */
    const sessionResponse = JSON.parse(data.content.sessionPreferences);
    // const newStartDate = new Date(sessionResponse.startDate);
    // const startDateTimeZone = newStartDate.getTimezoneOffset();
    // const newStartDateNeutral = new Date(
    //   newStartDate.getTime() + startDateTimeZone * 60 * 1000
    // );
    // const newEndDate = new Date(sessionResponse.endDate);
    // const endDateTimeZone = newEndDate.getTimezoneOffset();
    // const newEndDateNeutral = new Date(
    //   newEndDate.getTime() + endDateTimeZone * 60 * 1000
    // );
    // sessionResponse['startDate'] = newStartDateNeutral;
    // sessionResponse['endDate'] = newEndDateNeutral;
    const newSession = updateSession(sessionResponse);
    data.content["updatedSession"] = newSession;
    return data;
  }
};
